import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { GetSchemaAvailabilityFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetSchemaAvailabilityFragmentFragmentDoc';

/* GraphQL */ `
  fragment getSchemaAvailabilityFragment on Availability {
    state
  }
`;

export type GetSchemaAvailabilityProps = FragmentType<
  typeof GetSchemaAvailabilityFragmentFragmentDoc
>;

export const getSchemaAvailability = (data: GetSchemaAvailabilityProps) => {
  const { state } = getFragmentData(GetSchemaAvailabilityFragmentFragmentDoc, data);

  switch (state) {
    case 'NOT_AVAILABLE':
      return 'OutOfStock';
    case 'NOT_YET_AVAILABLE':
      return 'BackOrder';
    case 'AVAILABLE':
    case 'UNSELECTED':
    default:
      return 'InStock';
  }
};
